//에디터 (Summernote)
import 'summernote/dist/summernote-lite.js';
import 'summernote/dist/summernote-lite.css';

export default {

  data() {
    return {
    }
  },
  methods: {
    initSummernote(id, name, value) {
      let $this = this;
      let valueArr = value.split('.');
      $('#' + id).summernote({
        height: 500,
        lang: 'ko',
        placeholder: name+ '을 입력해주세요',
        disableResizeEditor: true,
        toolbar: [
            ['style', ['style']],
            ['fontsize', ['fontsize']],
            ['font', ['bold', 'italic', 'underline', 'clear']],
            ['fontname', ['fontname']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']],
            ['insert', ['picture', 'hr']],
            ['Insert', ['link']],
            ['Insert', ['video']],
            ['table', ['table']],
            ['codeview']
        ],
        popover: {
            image: [
              ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
              ['float', ['floatLeft', 'floatRight', 'floatNone']],
              ['remove', ['removeMedia']]
            ],
            link: [
              ['link', ['linkDialogShow', 'unlink']]
            ],
            table: [
              ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
              ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
            ],
            air: [
              ['color', ['color']],
              ['font', ['bold', 'underline', 'clear']],
              ['para', ['ul', 'paragraph']],
              ['table', ['table']],
              ['insert', ['link', 'picture']]
            ]
          },
        fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '24', '36', '48' , '64', '82', '150'],
        callbacks: {
          onChange: function() {
              if(valueArr.length > 1) {
                if($('#' + id).summernote('isEmpty')){
                  $this[valueArr[0]][valueArr[1]] = "";
                }else{
                  $this[valueArr[0]][valueArr[1]] = $('#' + id).summernote('code');
                }
              }
              if($('#' + id).summernote('isEmpty')){
                $this[value] = "";
              }else{
                $this[value] = $('#' + id).summernote('code');
              }
          },
          onImageUpload: function(files, editor, welEditable) {
            let formData = new FormData();
            formData.append('files', files[0]);
            $this.$api.$file.editorUpload(formData).then(res => {
              if(res.status === true){
                let dom = document.createElement('img');
                $(dom).attr('src', '' + res.file_name);
                $('#' + id).summernote('insertNode', dom);
              }else{
                status = res.reason;
              }
            })
          }
        }
      });
      $('#' + id).summernote('fontSize', 14);
    },
  }
}